// Mode configurations for different chat modes
// Keep this lightweight - only UI/behavior config, no data loading logic

export const CHAT_MODES = {
  general: {
    key: 'general',
    label: 'AI Forecast',
    desc: 'Quick questions and answers with your data.',
    themeColor: 'rgba(72, 143, 243, 1)',
    themeBg: 'rgba(72, 143, 243, 0.12)',
    themeBgActive: 'rgba(72, 143, 243, 0.20)',
    layoutView: 'full',
    researchMode: 'normal',
    greeting: {
      icon: null,
      title: <>Hello! <span role="img" aria-label="wave"> 👋</span></>,
      subtitle: "I'm here to build and manage your cash flow forecast.",
      // Structured sections for greeting display
      examples: [
        {
          title: 'Build',
          items: [
            'Connect to your accounting system and bank to get started.',
            'Work with the agent to build your forecast.',
            'Refine forecast until complete to your satisfaction.'
          ]
        },
        {
          title: 'Monitor',
          items: [
            'The agent will track cash inflows and outflows against the forecast.',
            'The agent will continuoully digest, learn, and improve the forecast.',
            'You remain in the loop as the agent adjusts assumptions.'
          ]
        },
        {
          title: 'Improve',
          items: [
            'The agent learns from late payers, vendor delays, and seasonal swings.',
            'The agent refines forecast to improve accuracy over time.',
            'The agent proactively recommends actions for your review.'
          ]
        }        
      ]
    },
    leftActions: ['plus', 'questionBank', 'modeSelector'],
    apiEndpoint: '/api/threads/chat',
    showForecastCanvas: false,
    showAgentHeader: false,
    agentName: 'AI Assistant'
  },
  // Additional modes can be added here in the future
  
};

// Helper function to get current mode config
export const getCurrentModeConfig = () => CHAT_MODES.general;

// Helper function to check if action should be shown
export const shouldShowAction = (_mode, action) => {
  const config = getCurrentModeConfig();
  return config.leftActions.includes(action);
};
